"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MetaDiffType () {
        return MetaDiffType;
    },
    get MetaDiffsService () {
        return MetaDiffsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _inflection = require("inflection");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _ModelXcMetaFactory = /*#__PURE__*/ _interop_require_default(require("~/db/sql-mgr/code/models/xc/ModelXcMetaFactory"));
const _getColumnUiType = /*#__PURE__*/ _interop_require_default(require("~/helpers/getColumnUiType"));
const _getTableName = /*#__PURE__*/ _interop_require_wildcard(require("~/helpers/getTableName"));
const _getUniqueName = require("~/helpers/getUniqueName");
const _mapDefaultDisplayValue = /*#__PURE__*/ _interop_require_default(require("~/helpers/mapDefaultDisplayValue"));
const _catchError = require("~/helpers/catchError");
const _NcHelp = /*#__PURE__*/ _interop_require_default(require("~/utils/NcHelp"));
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
var MetaDiffType = /*#__PURE__*/ function(MetaDiffType) {
    MetaDiffType["TABLE_NEW"] = "TABLE_NEW";
    MetaDiffType["TABLE_REMOVE"] = "TABLE_REMOVE";
    MetaDiffType["TABLE_COLUMN_ADD"] = "TABLE_COLUMN_ADD";
    MetaDiffType["TABLE_COLUMN_TYPE_CHANGE"] = "TABLE_COLUMN_TYPE_CHANGE";
    MetaDiffType["TABLE_COLUMN_PROPS_CHANGED"] = "TABLE_COLUMN_PROPS_CHANGED";
    MetaDiffType["TABLE_COLUMN_REMOVE"] = "TABLE_COLUMN_REMOVE";
    MetaDiffType["VIEW_NEW"] = "VIEW_NEW";
    MetaDiffType["VIEW_REMOVE"] = "VIEW_REMOVE";
    MetaDiffType["VIEW_COLUMN_ADD"] = "VIEW_COLUMN_ADD";
    MetaDiffType["VIEW_COLUMN_TYPE_CHANGE"] = "VIEW_COLUMN_TYPE_CHANGE";
    MetaDiffType["VIEW_COLUMN_REMOVE"] = "VIEW_COLUMN_REMOVE";
    MetaDiffType["TABLE_RELATION_ADD"] = "TABLE_RELATION_ADD";
    MetaDiffType["TABLE_RELATION_REMOVE"] = "TABLE_RELATION_REMOVE";
    MetaDiffType["TABLE_VIRTUAL_M2M_REMOVE"] = "TABLE_VIRTUAL_M2M_REMOVE";
    return MetaDiffType;
}({});
const applyChangesPriorityOrder = [
    "VIEW_COLUMN_REMOVE",
    "TABLE_RELATION_REMOVE"
];
let MetaDiffsService = class MetaDiffsService {
    async getMetaDiff(context, sqlClient, base, source) {
        var _data_list, _data, _this, _source_getConfig, _data1, _this1, _source_getConfig1, _data_list1, _data2, _this2, _source_getConfig2;
        // if meta base then return empty array
        if (source.isMeta()) {
            return [];
        }
        const changes = [];
        const virtualRelationColumns = [];
        // @ts-ignore
        const tableList = (_this = await sqlClient.tableList({
            schema: (_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema
        })) == null ? void 0 : (_data = _this.data) == null ? void 0 : (_data_list = _data.list) == null ? void 0 : _data_list.filter((t)=>{
            if ((base == null ? void 0 : base.prefix) && source.is_meta) {
                var _t_tn;
                return (_t_tn = t.tn) == null ? void 0 : _t_tn.startsWith(base == null ? void 0 : base.prefix);
            }
            return true;
        });
        const colListRef = {};
        const oldMetas = await source.getModels(context);
        // @ts-ignore
        const oldTableMetas = [];
        const oldViewMetas = [];
        for (const model of oldMetas){
            if (model.type === _nocodbsdk.ModelTypes.TABLE) oldTableMetas.push(model);
            else if (model.type === _nocodbsdk.ModelTypes.VIEW) oldViewMetas.push(model);
        }
        // @ts-ignore
        const relationList = (_this1 = await sqlClient.relationListAll({
            schema: (_source_getConfig1 = source.getConfig()) == null ? void 0 : _source_getConfig1.schema
        })) == null ? void 0 : (_data1 = _this1.data) == null ? void 0 : _data1.list;
        for (const table of tableList){
            var _data3, _this3, _source_getConfig3;
            if (table.tn === 'nc_evolutions') continue;
            const oldMetaIdx = oldTableMetas.findIndex((m)=>m.table_name === table.tn);
            // new table
            if (oldMetaIdx === -1) {
                changes.push({
                    table_name: table.tn,
                    source_id: source.id,
                    type: _nocodbsdk.ModelTypes.TABLE,
                    detectedChanges: [
                        {
                            type: "TABLE_NEW",
                            msg: `New table`
                        }
                    ]
                });
                continue;
            }
            const oldMeta = oldTableMetas[oldMetaIdx];
            oldTableMetas.splice(oldMetaIdx, 1);
            const tableProp = {
                title: oldMeta.title,
                meta: oldMeta.meta,
                table_name: table.tn,
                source_id: source.id,
                type: _nocodbsdk.ModelTypes.TABLE,
                detectedChanges: []
            };
            changes.push(tableProp);
            // check for column change
            colListRef[table.tn] = (_this3 = await sqlClient.columnList({
                tn: table.tn,
                schema: (_source_getConfig3 = source.getConfig()) == null ? void 0 : _source_getConfig3.schema
            })) == null ? void 0 : (_data3 = _this3.data) == null ? void 0 : _data3.list;
            await oldMeta.getColumns(context);
            for (const column of colListRef[table.tn]){
                const oldColIdx = oldMeta.columns.findIndex((c)=>c.column_name === column.cn);
                // new table
                if (oldColIdx === -1) {
                    tableProp.detectedChanges.push({
                        type: "TABLE_COLUMN_ADD",
                        msg: `New column(${column.cn})`,
                        cn: column.cn,
                        id: oldMeta.id
                    });
                    continue;
                }
                const [oldCol] = oldMeta.columns.splice(oldColIdx, 1);
                if (oldCol.dt !== column.dt || // if mysql and data type is set or enum then compare dtxp as well
                [
                    'mysql',
                    'mysql2'
                ].includes(source.type) && [
                    'set',
                    'enum'
                ].includes(column.dt) && column.dtxp !== oldCol.dtxp) {
                    tableProp.detectedChanges.push({
                        type: "TABLE_COLUMN_TYPE_CHANGE",
                        msg: `Column type changed(${column.cn})`,
                        cn: oldCol.column_name,
                        id: oldMeta.id,
                        column: oldCol
                    });
                }
                if (!!oldCol.pk !== !!column.pk || !!oldCol.rqd !== !!column.rqd || !!oldCol.un !== !!column.un || !!oldCol.ai !== !!column.ai || !!oldCol.unique !== !!column.unique) {
                    tableProp.detectedChanges.push({
                        type: "TABLE_COLUMN_PROPS_CHANGED",
                        msg: `Column properties changed (${column.cn})`,
                        cn: oldCol.column_name,
                        id: oldMeta.id,
                        column: oldCol
                    });
                }
            }
            for (const column of oldMeta.columns){
                if ([
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Lookup,
                    _nocodbsdk.UITypes.Formula,
                    _nocodbsdk.UITypes.QrCode,
                    _nocodbsdk.UITypes.Barcode,
                    _nocodbsdk.UITypes.Button
                ].includes(column.uidt) || (0, _nocodbsdk.isAIPromptCol)(column) || // skip alias columns of CreatedTime, LastModifiedTime, CreatedBy, LastModifiedBy
                [
                    _nocodbsdk.UITypes.CreatedTime,
                    _nocodbsdk.UITypes.LastModifiedTime,
                    _nocodbsdk.UITypes.LastModifiedBy,
                    _nocodbsdk.UITypes.CreatedBy
                ].includes(column.uidt) && !column.system) {
                    if ((0, _nocodbsdk.isLinksOrLTAR)(column.uidt)) {
                        virtualRelationColumns.push(column);
                    }
                    continue;
                }
                tableProp.detectedChanges.push({
                    type: "TABLE_COLUMN_REMOVE",
                    msg: `Column removed(${column.column_name})`,
                    cn: column.column_name,
                    id: oldMeta.id,
                    column: column,
                    colId: column.id
                });
            }
        }
        for (const model of oldTableMetas){
            changes.push({
                table_name: model.table_name,
                meta: model.meta,
                source_id: source.id,
                type: _nocodbsdk.ModelTypes.TABLE,
                detectedChanges: [
                    {
                        type: "TABLE_REMOVE",
                        msg: `Table removed`,
                        tn: model.table_name,
                        id: model.id,
                        model
                    }
                ]
            });
        }
        for (const relationCol of virtualRelationColumns){
            const colOpt = await relationCol.getColOptions(context);
            const parentCol = await colOpt.getParentColumn(context);
            const childCol = await colOpt.getChildColumn(context);
            if (!parentCol || !childCol) {
                // Parent or child column is missing - mark relation for removal
                const ownerModel = await relationCol.getModel(context);
                if (ownerModel) {
                    const ownerTable = changes.find((t)=>t.table_name === ownerModel.table_name);
                    if (ownerTable) {
                        ownerTable.detectedChanges.push({
                            type: "TABLE_RELATION_REMOVE",
                            msg: `Relation removed (${!parentCol ? 'parent' : 'child'} column missing)`,
                            colId: relationCol.id,
                            column: relationCol
                        });
                    }
                }
                continue;
            }
            const parentModel = await parentCol.getModel(context);
            const childModel = await childCol.getModel(context);
            if (!parentModel || !childModel) {
                // Parent or child model is missing - mark relation for removal
                const ownerModel = parentModel || childModel || await relationCol.getModel(context);
                if (ownerModel) {
                    const ownerTable = changes.find((t)=>t.table_name === ownerModel.table_name);
                    if (ownerTable) {
                        ownerTable.detectedChanges.push({
                            type: "TABLE_RELATION_REMOVE",
                            msg: `Relation removed (${!parentModel ? 'parent' : 'child'} table missing)`,
                            colId: relationCol.id,
                            column: relationCol
                        });
                    }
                }
                continue;
            }
            // many to many relation
            if (colOpt.type === _nocodbsdk.RelationTypes.MANY_TO_MANY) {
                var _data4, _this4, _source_getConfig4, _data5, _this5, _source_getConfig5, _data6, _this6, _source_getConfig6;
                const m2mModel = await colOpt.getMMModel(context);
                if (!m2mModel) {
                    // M2M model is missing - mark relation for removal
                    const ownerTable = changes.find((t)=>t.table_name === childModel.table_name);
                    if (ownerTable) {
                        ownerTable.detectedChanges.push({
                            type: "TABLE_VIRTUAL_M2M_REMOVE",
                            msg: `Many to many removed (junction table missing)`,
                            colId: relationCol.id,
                            column: relationCol
                        });
                    }
                    continue;
                }
                const relatedTable = tableList.find((t)=>t.tn === parentModel.table_name);
                const m2mTable = tableList.find((t)=>t.tn === m2mModel.table_name);
                if (!relatedTable) {
                    changes.find((t)=>t.table_name === childModel.table_name).detectedChanges.push({
                        type: "TABLE_VIRTUAL_M2M_REMOVE",
                        msg: `Many to many removed(${parentModel.table_name} removed)`,
                        colId: relationCol.id,
                        column: relationCol
                    });
                    continue;
                }
                if (!m2mTable) {
                    changes.find((t)=>t.table_name === childModel.table_name).detectedChanges.push({
                        type: "TABLE_VIRTUAL_M2M_REMOVE",
                        msg: `Many to many removed(${m2mModel.table_name} removed)`,
                        colId: relationCol.id,
                        column: relationCol
                    });
                    continue;
                }
                // verify columns
                const cColumns = colListRef[childModel.table_name] = colListRef[childModel.table_name] || ((_this4 = await sqlClient.columnList({
                    tn: childModel.table_name,
                    schema: (_source_getConfig4 = source.getConfig()) == null ? void 0 : _source_getConfig4.schema
                })) == null ? void 0 : (_data4 = _this4.data) == null ? void 0 : _data4.list);
                const pColumns = colListRef[parentModel.table_name] = colListRef[parentModel.table_name] || ((_this5 = await sqlClient.columnList({
                    tn: parentModel.table_name,
                    schema: (_source_getConfig5 = source.getConfig()) == null ? void 0 : _source_getConfig5.schema
                })) == null ? void 0 : (_data5 = _this5.data) == null ? void 0 : _data5.list);
                const vColumns = colListRef[m2mTable.tn] = colListRef[m2mTable.tn] || ((_this6 = await sqlClient.columnList({
                    tn: m2mTable.tn,
                    schema: (_source_getConfig6 = source.getConfig()) == null ? void 0 : _source_getConfig6.schema
                })) == null ? void 0 : (_data6 = _this6.data) == null ? void 0 : _data6.list);
                const m2mChildCol = await colOpt.getMMChildColumn(context);
                const m2mParentCol = await colOpt.getMMParentColumn(context);
                if (pColumns.every((c)=>c.cn !== parentCol.column_name) || cColumns.every((c)=>c.cn !== childCol.column_name) || vColumns.every((c)=>c.cn !== m2mChildCol.column_name) || vColumns.every((c)=>c.cn !== m2mParentCol.column_name)) {
                    changes.find((t)=>t.table_name === childModel.table_name).detectedChanges.push({
                        type: "TABLE_VIRTUAL_M2M_REMOVE",
                        msg: `Many to many removed(One of the relation column removed)`,
                        colId: relationCol.id,
                        column: relationCol
                    });
                }
                continue;
            }
            if (relationCol.colOptions.virtual) continue;
            const dbRelation = relationList.find((r)=>r.cn === childCol.column_name && r.tn === childModel.table_name && r.rcn === parentCol.column_name && r.rtn === parentModel.table_name);
            if (dbRelation) {
                dbRelation.found = dbRelation.found || {};
                if (dbRelation.found[colOpt.type]) {
                // todo: handle duplicate
                } else {
                    dbRelation.found[colOpt.type] = true;
                }
            } else {
                changes.find((t)=>{
                    var _relationCol_meta;
                    return t.table_name === (colOpt.type === _nocodbsdk.RelationTypes.BELONGS_TO || colOpt.type === _nocodbsdk.RelationTypes.ONE_TO_ONE && ((_relationCol_meta = relationCol.meta) == null ? void 0 : _relationCol_meta.bt) ? childModel.table_name : parentModel.table_name);
                }).detectedChanges.push({
                    type: "TABLE_RELATION_REMOVE",
                    tn: childModel.table_name,
                    rtn: parentModel.table_name,
                    cn: childCol.column_name,
                    rcn: parentCol.column_name,
                    msg: `Relation removed`,
                    colId: relationCol.id,
                    column: relationCol
                });
            }
        }
        for (const relation of relationList){
            var _relation_found, _relation_found1, _relation_found2, _relation_found3;
            if (!(relation == null ? void 0 : (_relation_found = relation.found) == null ? void 0 : _relation_found[_nocodbsdk.RelationTypes.BELONGS_TO]) && !(relation == null ? void 0 : (_relation_found1 = relation.found) == null ? void 0 : _relation_found1[_nocodbsdk.RelationTypes.ONE_TO_ONE])) {
                var _changes_find;
                (_changes_find = changes.find((t)=>t.table_name === relation.tn)) == null ? void 0 : _changes_find.detectedChanges.push({
                    type: "TABLE_RELATION_ADD",
                    tn: relation.tn,
                    rtn: relation.rtn,
                    cn: relation.cn,
                    rcn: relation.rcn,
                    msg: `New relation added`,
                    relationType: _nocodbsdk.RelationTypes.BELONGS_TO,
                    cstn: relation.cstn
                });
            }
            if (!(relation == null ? void 0 : (_relation_found2 = relation.found) == null ? void 0 : _relation_found2[_nocodbsdk.RelationTypes.HAS_MANY]) && !(relation == null ? void 0 : (_relation_found3 = relation.found) == null ? void 0 : _relation_found3[_nocodbsdk.RelationTypes.ONE_TO_ONE])) {
                var _changes_find1;
                (_changes_find1 = changes.find((t)=>t.table_name === relation.rtn)) == null ? void 0 : _changes_find1.detectedChanges.push({
                    type: "TABLE_RELATION_ADD",
                    tn: relation.tn,
                    rtn: relation.rtn,
                    cn: relation.cn,
                    rcn: relation.rcn,
                    msg: `New relation added`,
                    relationType: _nocodbsdk.RelationTypes.HAS_MANY
                });
            }
        }
        // views
        // @ts-ignore
        const viewList = (_this2 = await sqlClient.viewList({
            schema: (_source_getConfig2 = source.getConfig()) == null ? void 0 : _source_getConfig2.schema
        })) == null ? void 0 : (_data2 = _this2.data) == null ? void 0 : (_data_list1 = _data2.list) == null ? void 0 : _data_list1.map((v)=>{
            v.type = 'view';
            v.tn = v.view_name;
            return v;
        }).filter((t)=>{
            if ((base == null ? void 0 : base.prefix) && source.is_meta) {
                var _t_tn;
                return (_t_tn = t.tn) == null ? void 0 : _t_tn.startsWith(base == null ? void 0 : base.prefix);
            }
            return true;
        }); // @ts-ignore
        for (const view of viewList){
            var _data7, _this7, _source_getConfig7;
            const oldMetaIdx = oldViewMetas.findIndex((m)=>m.table_name === view.tn);
            // new table
            if (oldMetaIdx === -1) {
                changes.push({
                    table_name: view.tn,
                    source_id: source.id,
                    type: _nocodbsdk.ModelTypes.VIEW,
                    detectedChanges: [
                        {
                            type: "VIEW_NEW",
                            msg: `New view`
                        }
                    ]
                });
                continue;
            }
            const oldMeta = oldViewMetas[oldMetaIdx];
            oldViewMetas.splice(oldMetaIdx, 1);
            const tableProp = {
                title: oldMeta.title,
                meta: oldMeta.meta,
                table_name: view.tn,
                source_id: source.id,
                type: _nocodbsdk.ModelTypes.VIEW,
                detectedChanges: []
            };
            changes.push(tableProp);
            // check for column change
            colListRef[view.tn] = (_this7 = await sqlClient.columnList({
                tn: view.tn,
                schema: (_source_getConfig7 = source.getConfig()) == null ? void 0 : _source_getConfig7.schema
            })) == null ? void 0 : (_data7 = _this7.data) == null ? void 0 : _data7.list;
            await oldMeta.getColumns(context);
            for (const column of colListRef[view.tn]){
                const oldColIdx = oldMeta.columns.findIndex((c)=>c.column_name === column.cn);
                // new table
                if (oldColIdx === -1) {
                    tableProp.detectedChanges.push({
                        type: "VIEW_COLUMN_ADD",
                        msg: `New column(${column.cn})`,
                        cn: column.cn,
                        id: oldMeta.id
                    });
                    continue;
                }
                const [oldCol] = oldMeta.columns.splice(oldColIdx, 1);
                if (oldCol.dt !== column.dt || // if mysql and data type is set or enum then compare dtxp as well
                [
                    'mysql',
                    'mysql2'
                ].includes(source.type) && [
                    'set',
                    'enum'
                ].includes(column.dt) && column.dtxp !== oldCol.dtxp) {
                    tableProp.detectedChanges.push({
                        type: "TABLE_COLUMN_TYPE_CHANGE",
                        msg: `Column type changed(${column.cn})`,
                        cn: oldCol.column_name,
                        id: oldMeta.id,
                        column: oldCol
                    });
                }
            }
            for (const column of oldMeta.columns){
                if ([
                    _nocodbsdk.UITypes.LinkToAnotherRecord,
                    _nocodbsdk.UITypes.Rollup,
                    _nocodbsdk.UITypes.Lookup,
                    _nocodbsdk.UITypes.Formula,
                    _nocodbsdk.UITypes.Links,
                    _nocodbsdk.UITypes.QrCode,
                    _nocodbsdk.UITypes.Barcode
                ].includes(column.uidt)) {
                    continue;
                }
                tableProp.detectedChanges.push({
                    type: "VIEW_COLUMN_REMOVE",
                    msg: `Column removed(${column.column_name})`,
                    cn: column.column_name,
                    id: oldMeta.id,
                    column: column,
                    colId: column.id
                });
            }
        }
        for (const model of oldViewMetas){
            changes.push({
                table_name: model.table_name,
                meta: model.meta,
                source_id: source.id,
                type: _nocodbsdk.ModelTypes.TABLE,
                detectedChanges: [
                    {
                        type: "VIEW_REMOVE",
                        msg: `Table removed`,
                        tn: model.table_name,
                        id: model.id,
                        model
                    }
                ]
            });
        }
        return changes;
    }
    async metaDiff(context, param) {
        const base = await _models.Base.getWithInfo(context, param.baseId);
        let changes = [];
        for (const source of base.sources){
            try {
                // skip meta base
                if (source.isMeta()) continue;
                // @ts-ignore
                const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source);
                changes = changes.concat(await this.getMetaDiff(context, sqlClient, base, source));
            } catch (e) {
                console.log(e);
            }
        }
        return changes;
    }
    async baseMetaDiff(context, param) {
        const base = await _models.Base.getWithInfo(context, param.baseId);
        const source = await _models.Source.get(context, param.sourceId);
        let changes = [];
        const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source);
        changes = await this.getMetaDiff(context, sqlClient, base, source);
        return changes;
    }
    async syncBaseMeta(context, { base, source, throwOnFail = false, logger, user }) {
        var _source_type;
        if (source.isMeta()) {
            if (throwOnFail) _catchError.NcError.badRequest('Cannot sync meta source');
            return;
        }
        const virtualColumnInsert = [];
        logger == null ? void 0 : logger(`Getting meta diff for ${source.alias}`);
        // @ts-ignore
        const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source);
        const sqlUi = _nocodbsdk.SqlUiFactory.create({
            client: (_source_type = source.type) != null ? _source_type : _nocodbsdk.ClientType.PG
        });
        const changes = await this.getMetaDiff(context, sqlClient, base, source);
        /* Get all relations */ // const relations = (await sqlClient.relationListAll())?.data?.list;
        for (const { table_name, detectedChanges } of changes){
            // reorder changes to apply relation remove changes
            // before column remove to avoid foreign key constraint error
            detectedChanges.sort((a, b)=>{
                return applyChangesPriorityOrder.indexOf(b.type) - applyChangesPriorityOrder.indexOf(a.type);
            });
            if (detectedChanges.length === 0) {
                logger == null ? void 0 : logger(`No changes detected for ${table_name}`);
                continue;
            }
            logger == null ? void 0 : logger(`Applying changes for ${table_name}`);
            for (const change of detectedChanges){
                logger == null ? void 0 : logger(`Applying change: ${change.msg}`);
                switch(change.type){
                    case "TABLE_NEW":
                        {
                            var _data_list, _data, _this, _source_getConfig;
                            const columns = (_this = await sqlClient.columnList({
                                tn: table_name,
                                schema: (_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema
                            })) == null ? void 0 : (_data = _this.data) == null ? void 0 : (_data_list = _data.list) == null ? void 0 : _data_list.map((c)=>_extends({}, c, {
                                    column_name: c.cn
                                }));
                            (0, _mapDefaultDisplayValue.default)(columns);
                            const model = await _models.Model.insert(context, base.id, source.id, {
                                table_name: table_name,
                                title: (0, _getTableName.default)(table_name, source.is_meta ? base.prefix : '', source),
                                type: _nocodbsdk.ModelTypes.TABLE,
                                user_id: user.id
                            });
                            for (const column of columns){
                                await _models.Column.insert(context, _extends({
                                    uidt: (0, _getColumnUiType.default)(source, column),
                                    fk_model_id: model.id
                                }, column, {
                                    title: (0, _getTableName.getColumnNameAlias)(column.column_name, source)
                                }));
                            }
                        }
                        break;
                    case "VIEW_NEW":
                        {
                            var _data_list1, _data1, _this1, _source_getConfig1;
                            const columns = (_this1 = await sqlClient.columnList({
                                tn: table_name,
                                schema: (_source_getConfig1 = source.getConfig()) == null ? void 0 : _source_getConfig1.schema
                            })) == null ? void 0 : (_data1 = _this1.data) == null ? void 0 : (_data_list1 = _data1.list) == null ? void 0 : _data_list1.map((c)=>_extends({}, c, {
                                    column_name: c.cn
                                }));
                            (0, _mapDefaultDisplayValue.default)(columns);
                            const model = await _models.Model.insert(context, base.id, source.id, {
                                table_name: table_name,
                                title: (0, _getTableName.default)(table_name, base.prefix, source),
                                type: _nocodbsdk.ModelTypes.VIEW,
                                user_id: user.id
                            });
                            for (const column of columns){
                                await _models.Column.insert(context, _extends({
                                    uidt: (0, _getColumnUiType.default)(source, column),
                                    fk_model_id: model.id
                                }, column, {
                                    title: (0, _getTableName.getColumnNameAlias)(column.column_name, source)
                                }));
                            }
                        }
                        break;
                    case "TABLE_REMOVE":
                    case "VIEW_REMOVE":
                        {
                            await change.model.delete(context);
                        }
                        break;
                    case "TABLE_COLUMN_ADD":
                    case "VIEW_COLUMN_ADD":
                        {
                            var _data_list2, _data2, _this2, _source_getConfig2;
                            const columns = (_this2 = await sqlClient.columnList({
                                tn: table_name,
                                schema: (_source_getConfig2 = source.getConfig()) == null ? void 0 : _source_getConfig2.schema
                            })) == null ? void 0 : (_data2 = _this2.data) == null ? void 0 : (_data_list2 = _data2.list) == null ? void 0 : _data_list2.map((c)=>_extends({}, c, {
                                    column_name: c.cn
                                }));
                            const column = columns.find((c)=>c.cn === change.cn);
                            column.uidt = (0, _getColumnUiType.default)(source, column);
                            //todo: inflection
                            column.title = (0, _getTableName.getColumnNameAlias)(column.cn, source);
                            await _models.Column.insert(context, _extends({
                                fk_model_id: change.id
                            }, column));
                        }
                        break;
                    case "TABLE_COLUMN_TYPE_CHANGE":
                    case "VIEW_COLUMN_TYPE_CHANGE":
                        {
                            var _data_list3, _data3, _this3, _source_getConfig3;
                            const columns = (_this3 = await sqlClient.columnList({
                                tn: table_name,
                                schema: (_source_getConfig3 = source.getConfig()) == null ? void 0 : _source_getConfig3.schema
                            })) == null ? void 0 : (_data3 = _this3.data) == null ? void 0 : (_data_list3 = _data3.list) == null ? void 0 : _data_list3.map((c)=>_extends({}, c, {
                                    column_name: c.cn
                                }));
                            const column = columns.find((c)=>c.cn === change.cn);
                            const metaFact = _ModelXcMetaFactory.default.create({
                                client: source.type
                            }, {});
                            // check if new type is compatible with old uidt
                            const allowedDatatypes = sqlUi.getDataTypeListForUiType(column);
                            // if UIDT not compatible with new type then change uidt
                            if (!(allowedDatatypes == null ? void 0 : allowedDatatypes.includes(column.dt))) {
                                column.uidt = metaFact.getUIDataType(column);
                            }
                            column.title = change.column.title;
                            await _models.Column.update(context, change.column.id, column);
                        }
                        break;
                    case "TABLE_COLUMN_PROPS_CHANGED":
                        {
                            var _data_list4, _data4, _this4;
                            const columns = (_this4 = await sqlClient.columnList({
                                tn: table_name
                            })) == null ? void 0 : (_data4 = _this4.data) == null ? void 0 : (_data_list4 = _data4.list) == null ? void 0 : _data_list4.map((c)=>_extends({}, c, {
                                    column_name: c.cn
                                }));
                            const colMeta = columns.find((c)=>c.cn === change.cn);
                            if (!colMeta) break;
                            const { pk, ai, rqd, un, unique } = colMeta;
                            await _models.Column.update(context, change.column.id, {
                                pk,
                                ai,
                                rqd,
                                un,
                                unique
                            });
                        }
                        break;
                    case "TABLE_COLUMN_REMOVE":
                    case "VIEW_COLUMN_REMOVE":
                        await change.column.delete(context);
                        break;
                    case "TABLE_RELATION_REMOVE":
                    case "TABLE_VIRTUAL_M2M_REMOVE":
                        await change.column.delete(context);
                        break;
                    case "TABLE_RELATION_ADD":
                        {
                            virtualColumnInsert.push(async ()=>{
                                const parentModel = await _models.Model.getByIdOrName(context, {
                                    base_id: source.base_id,
                                    source_id: source.id,
                                    table_name: change.rtn
                                });
                                const childModel = await _models.Model.getByIdOrName(context, {
                                    base_id: source.base_id,
                                    source_id: source.id,
                                    table_name: change.tn
                                });
                                // Skip relation creation if either the parent or child table is missing.
                                // This can happen if the database user has access limited to specific tables,
                                // making it unable to create the relation. In such cases, we simply skip.
                                if (!parentModel || !childModel) {
                                    logger == null ? void 0 : logger(`Skipping relation creation for ${change.tn} and ${change.rtn} because one of the tables is missing or the database user lacks access.`);
                                    return;
                                }
                                const parentCol = await parentModel.getColumns(context).then((cols)=>cols.find((c)=>c.column_name === change.rcn));
                                const childCol = await childModel.getColumns(context).then((cols)=>cols.find((c)=>c.column_name === change.cn));
                                await _models.Column.update(context, childCol.id, _extends({}, childCol, {
                                    uidt: _nocodbsdk.UITypes.ForeignKey,
                                    system: true
                                }));
                                if (change.relationType === _nocodbsdk.RelationTypes.BELONGS_TO) {
                                    const title = (0, _getUniqueName.getUniqueColumnAliasName)(childModel.columns, `${parentModel.title || parentModel.table_name}`);
                                    await _models.Column.insert(context, {
                                        uidt: _nocodbsdk.UITypes.LinkToAnotherRecord,
                                        title,
                                        fk_model_id: childModel.id,
                                        fk_related_model_id: parentModel.id,
                                        type: _nocodbsdk.RelationTypes.BELONGS_TO,
                                        fk_parent_column_id: parentCol.id,
                                        fk_child_column_id: childCol.id,
                                        virtual: false,
                                        fk_index_name: change.cstn
                                    });
                                } else if (change.relationType === _nocodbsdk.RelationTypes.HAS_MANY) {
                                    const title = (0, _getUniqueName.getUniqueColumnAliasName)(childModel.columns, (0, _inflection.pluralize)(childModel.title || childModel.table_name));
                                    await _models.Column.insert(context, {
                                        uidt: _nocodbsdk.UITypes.Links,
                                        title,
                                        fk_model_id: parentModel.id,
                                        fk_related_model_id: childModel.id,
                                        type: _nocodbsdk.RelationTypes.HAS_MANY,
                                        fk_parent_column_id: parentCol.id,
                                        fk_child_column_id: childCol.id,
                                        virtual: false,
                                        fk_index_name: change.cstn,
                                        meta: {
                                            plural: (0, _inflection.pluralize)(childModel.title),
                                            singular: (0, _inflection.singularize)(childModel.title)
                                        }
                                    });
                                }
                            });
                        }
                        break;
                }
            }
            logger == null ? void 0 : logger(`Changes applied for ${table_name}`);
        }
        logger == null ? void 0 : logger(`Processing virtual column changes`);
        await _NcHelp.default.executeOperations(virtualColumnInsert, source.type);
        logger == null ? void 0 : logger(`Virtual column changes applied`);
        logger == null ? void 0 : logger(`Processing many to many relation changes`);
        // populate m2m relations
        await this.extractAndGenerateManyToManyRelations(context, await source.getModels(context));
        logger == null ? void 0 : logger(`Many to many relation changes applied`);
    }
    async metaDiffSync(context, param) {
        const base = await _models.Base.getWithInfo(context, param.baseId);
        for (const source of base.sources){
            await this.syncBaseMeta(context, {
                base,
                source,
                logger: param.logger,
                user: param.req.user
            });
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.META_DIFF_SYNC, {
            base,
            req: param.req,
            context
        });
        return true;
    }
    async baseMetaDiffSync(context, param) {
        const base = await _models.Base.getWithInfo(context, param.baseId);
        const source = await _models.Source.get(context, param.sourceId);
        await this.syncBaseMeta(context, {
            base,
            source,
            throwOnFail: true,
            logger: param.logger,
            user: param.req.user
        });
        this.appHooksService.emit(_nocodbsdk.AppEvents.META_DIFF_SYNC, {
            base,
            source,
            req: param.req,
            context
        });
        return true;
    }
    async isMMRelationExist(context, model, assocModel, belongsToCol) {
        let isExist = false;
        const colChildOpt = await belongsToCol.getColOptions(context);
        for (const col of (await model.getColumns(context))){
            if ((0, _nocodbsdk.isLinksOrLTAR)(col.uidt)) {
                const colOpt = await col.getColOptions(context);
                if (colOpt && colOpt.type === _nocodbsdk.RelationTypes.MANY_TO_MANY && colOpt.fk_mm_model_id === assocModel.id && colOpt.fk_child_column_id === colChildOpt.fk_parent_column_id && colOpt.fk_mm_child_column_id === colChildOpt.fk_child_column_id) {
                    isExist = true;
                    break;
                }
            }
        }
        return isExist;
    }
    // @ts-ignore
    async extractAndGenerateManyToManyRelations(context, modelsArr) {
        for (const assocModel of modelsArr){
            await assocModel.getColumns(context);
            // check if table is a Bridge table(or Associative Table) by checking
            // number of foreign keys and columns
            const normalColumns = assocModel.columns.filter((c)=>!(0, _nocodbsdk.isVirtualCol)(c));
            const belongsToCols = [];
            for (const col of assocModel.columns){
                if (col.uidt == _nocodbsdk.UITypes.LinkToAnotherRecord) {
                    const colOpt = await col.getColOptions(context);
                    if ((colOpt == null ? void 0 : colOpt.type) === _nocodbsdk.RelationTypes.BELONGS_TO) belongsToCols.push(col);
                }
            }
            // todo: impl better method to identify m2m relation
            if ((belongsToCols == null ? void 0 : belongsToCols.length) === 2 && normalColumns.length < 5 && assocModel.primaryKeys.length === 2) {
                // Ensure colOptions are populated
                if (!belongsToCols[0].colOptions || !belongsToCols[1].colOptions) {
                    continue;
                }
                const modelA = await belongsToCols[0].colOptions.getRelatedTable(context);
                const modelB = await belongsToCols[1].colOptions.getRelatedTable(context);
                if (!modelA || !modelB) {
                    continue;
                }
                await modelA.getColumns(context);
                await modelB.getColumns(context);
                // check tableA already have the relation or not
                const isRelationAvailInA = await this.isMMRelationExist(context, modelA, assocModel, belongsToCols[0]);
                const isRelationAvailInB = await this.isMMRelationExist(context, modelB, assocModel, belongsToCols[1]);
                if (!isRelationAvailInA) {
                    await _models.Column.insert(context, {
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(modelA.columns, (0, _inflection.pluralize)(modelB.title)),
                        fk_model_id: modelA.id,
                        fk_related_model_id: modelB.id,
                        fk_mm_model_id: assocModel.id,
                        fk_child_column_id: belongsToCols[0].colOptions.fk_parent_column_id,
                        fk_parent_column_id: belongsToCols[1].colOptions.fk_parent_column_id,
                        fk_mm_child_column_id: belongsToCols[0].colOptions.fk_child_column_id,
                        fk_mm_parent_column_id: belongsToCols[1].colOptions.fk_child_column_id,
                        type: _nocodbsdk.RelationTypes.MANY_TO_MANY,
                        uidt: _nocodbsdk.UITypes.Links,
                        meta: {
                            plural: (0, _inflection.pluralize)(modelB.title),
                            singular: (0, _inflection.singularize)(modelB.title)
                        }
                    });
                }
                if (!isRelationAvailInB) {
                    await _models.Column.insert(context, {
                        title: (0, _getUniqueName.getUniqueColumnAliasName)(modelB.columns, (0, _inflection.pluralize)(modelA.title)),
                        fk_model_id: modelB.id,
                        fk_related_model_id: modelA.id,
                        fk_mm_model_id: assocModel.id,
                        fk_child_column_id: belongsToCols[1].colOptions.fk_parent_column_id,
                        fk_parent_column_id: belongsToCols[0].colOptions.fk_parent_column_id,
                        fk_mm_child_column_id: belongsToCols[1].colOptions.fk_child_column_id,
                        fk_mm_parent_column_id: belongsToCols[0].colOptions.fk_child_column_id,
                        type: _nocodbsdk.RelationTypes.MANY_TO_MANY,
                        uidt: _nocodbsdk.UITypes.Links,
                        meta: {
                            plural: (0, _inflection.pluralize)(modelA.title),
                            singular: (0, _inflection.singularize)(modelA.title)
                        }
                    });
                }
                await _models.Model.markAsMmTable(context, assocModel.id, true);
                // mark has many relation associated with mm as system field in both table
                for (const btCol of [
                    belongsToCols[0],
                    belongsToCols[1]
                ]){
                    const colOpt = await btCol.colOptions;
                    const model = await colOpt.getRelatedTable(context);
                    if (!model) {
                        continue;
                    }
                    for (const col of (await model.getColumns(context))){
                        if (!(0, _nocodbsdk.isLinksOrLTAR)(col.uidt)) continue;
                        const colOpt1 = await col.getColOptions(context);
                        if (!colOpt1 || colOpt1.type !== _nocodbsdk.RelationTypes.HAS_MANY) continue;
                        if (colOpt1.fk_child_column_id !== colOpt.fk_child_column_id || colOpt1.fk_parent_column_id !== colOpt.fk_parent_column_id) continue;
                        await _models.Column.markAsSystemField(context, col.id);
                        break;
                    }
                }
            } else {
                if (assocModel.mm) await _models.Model.markAsMmTable(context, assocModel.id, false);
            }
        }
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
MetaDiffsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], MetaDiffsService);
